import React from 'react';
import './Hero.css';

const Hero = ({ setCurrentSection }) => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Master Your Anger, <span className="highlight">Transform Your Life</span>
          </h1>
          <p className="hero-subtitle">
            Discover powerful tools and proven techniques to manage anger effectively, 
            build healthier relationships, and create a more peaceful world.
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">7+</span>
              <span className="stat-label">Proven Techniques</span>
            </div>
            <div className="stat">
              <span className="stat-number">5</span>
              <span className="stat-label">Interactive Tools</span>
            </div>
            <div className="stat">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Available Support</span>
            </div>
          </div>
          <div className="hero-cta">
            <button 
              className="cta-primary" 
              onClick={() => setCurrentSection('resources')}
            >
              Start Your Journey
            </button>
            <button 
              className="cta-secondary" 
              onClick={() => setCurrentSection('resources')}
            >
              Learn More
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="peace-symbol">☮️</div>
          <div className="floating-elements">
            <span className="element">🧘</span>
            <span className="element">🌿</span>
            <span className="element">💙</span>
            <span className="element">✨</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 